module.exports = __webpack_public_path__ + "static/media/S1P4_lifetime-risk.25840693.mp3";